import {$authHost, $host} from "./index";
import { fetchCsrfToken } from "./userAPI";

export const fetchCategories = async () => {
    const {data} = await $host.get('api/category');
    return data;
}

export const fetchSizes = async (type, category) => {
    const params = {};
    if (type) params.type = type;
    if (category) params.category = category;
    const {data} = await $host.get('api/size', { params });
    return data;
}

export const createProduct = async (product) => {
    const csrfToken = await fetchCsrfToken();
    let dataToSend;
    if (product instanceof FormData) {
        product.append('_csrf', csrfToken);
        dataToSend = product;
    } else {
        dataToSend = { ...product, _csrf: csrfToken };
    }
    const {data} = await $authHost.post('api/product', dataToSend)
    return data
}

export const fetchProducts = async (params) => {
    // Унифицируем формат размеров: backend теперь сам понимает size[], size[0], size[1]...
    const queryParams = params ? { ...params } : {};
    if (queryParams.sizes) delete queryParams.sizes;
    const { data } = await $host.get('api/product', { params: queryParams });
    return data;
}

export const fetchOneProduct = async (id) => {
    const {data} = await $host.get('api/product/' + id)
    return data
}

export const updateProduct = async (id, product, isMultipart = false) => {
    try {
        const csrfToken = await fetchCsrfToken();
        let dataToSend = product;
        let config = isMultipart ? { headers: { 'Content-Type': 'multipart/form-data' } } : {};
        if (isMultipart && product instanceof FormData) {
            product.append('_csrf', csrfToken);
            dataToSend = product;
        } else if (!isMultipart) {
            dataToSend = { ...product, _csrf: csrfToken };
        }
        const {data} = await $authHost.patch('api/product/' + id, dataToSend, config);
        return data;
    } catch (error) {
        console.error('Error in updateProduct API call:', error);
        throw error;
    }
}

export const deleteProduct = async (id) => {
    try {
        const csrfToken = await fetchCsrfToken();
        const {data} = await $authHost.delete('api/product/' + id, { data: { _csrf: csrfToken } });
        return data
    } catch (error) {
        console.error('Error in deleteProduct API call:', error)
        throw error
    }
}

export const deleteZeroStockProducts = async () => {
    try {
        const csrfToken = await fetchCsrfToken();
        const { data } = await $authHost.delete('api/product/bulk/zero-stock', { data: { _csrf: csrfToken } });
        return data;
    } catch (error) {
        console.error('Error in deleteZeroStockProducts API call:', error);
        throw error;
    }
}

export const recalculateAllProductQuantities = async () => {
    try {
        const csrfToken = await fetchCsrfToken();
        const { data } = await $authHost.post('api/product/bulk/recalculate-quantities', { _csrf: csrfToken });
        return data;
    } catch (error) {
        console.error('Error in recalculateAllProductQuantities API call:', error);
        throw error;
    }
}

export const applyDiscountByCategory = async (categoryId, discount) => {
    try {
        const csrfToken = await fetchCsrfToken();
        const { data } = await $authHost.post('api/product/bulk/discount/by-category', {
            categoryId,
            discount,
            _csrf: csrfToken
        });
        return data;
    } catch (error) {
        console.error('Error in applyDiscountByCategory API call:', error);
        throw error;
    }
}

export const createCategory = async (category) => {
    const csrfToken = await fetchCsrfToken();
    const { data } = await $authHost.post('api/category', { ...category, _csrf: csrfToken });
    return data;
};

export const updateCategory = async (id, category) => {
    console.log('=== UPDATE CATEGORY API ===');
    console.log('ID:', id);
    console.log('Category data:', category);
    
    const csrfToken = await fetchCsrfToken();
    const { data } = await $authHost.patch(`api/category/${id}`, { ...category, _csrf: csrfToken });
    
    console.log('API response:', data);
    return data;
};

export const fetchProductByBarcode = async (barcode) => {
    const {data} = await $authHost.get('api/product/barcode/' + barcode)
    return data
}

export const fetchStores = async () => {
    const {data} = await $host.get('api/store')
    return data
}

export const fetchStockByStore = async (storeId) => {
    const {data} = await $authHost.get('api/product/stock/store', { params: { storeId } });
    return data;
};

export const fetchStockByCategory = async (categoryId) => {
    const params = {};
    if (categoryId) params.categoryId = categoryId;
    const {data} = await $authHost.get('api/product/stock/category', { params });
    return data;
};

export const fetchStockByType = async (type) => {
    const {data} = await $authHost.get('api/product/stock/type', { params: { type } });
    return data;
};

export const createRating = async (productId, score, comment) => {
    try {
        const csrfToken = await fetchCsrfToken();
        const { data } = await $authHost.post('api/rating', { 
            productId, 
            score, 
            comment,
            _csrf: csrfToken
        });
        return data;
    } catch (e) {
        console.error('Ошибка при отправке оценки:', e);
        throw e;
    }
};

export const fetchProductsByIds = async (ids) => {
    const { data } = await $host.post('api/product/bulk', { ids });
    return data;
}

export const deleteCategory = async (id) => {
    try {
        const csrfToken = await fetchCsrfToken();
        const { data } = await $authHost.delete('api/category/' + id, { data: { _csrf: csrfToken } });
        return data;
    } catch (error) {
        console.error('Error in deleteCategory API call:', error);
        throw error;
    }
};